import ErrorBoundary from "components/error-fallbacks/ErrorFallBack";
import SectionHeading from "components/shared/SectionHeading";
import SubText from "components/shared/SubText";
import CreatorArtistSkeleton from "components/skeleton/CreatorArtistSkeleton";
import { RouteName } from "constant/routeNames";
import React, { lazy, Suspense, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CreatorService from "services/creators/CreatorService";
import { Navigation, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";

const CreatorCard = lazy(() => import("pages/videoPage/shared/CreatorCard"));

function WelcomePageCreatorArtist() {
  const [creators, setCreators] = useState([]);
  const [isLoading, setIsLoding] = useState<any>(false);

  useEffect(() => {
    setIsLoding(true);
    CreatorService.getNewAllCreators()
      .then((res) => {
        setIsLoding(false);
        setCreators(res.data);
        // console.log(creators);
      })
      .catch((e) => {
        setIsLoding(false);
        console.log(e);
      });
  }, []);

  return (
    <div>
      {!isLoading && (
        <>
          <ErrorBoundary>
            <Suspense fallback={<CreatorArtistSkeleton />}>
              <div className="mt-10 flex w-[95%] justify-between max-sm:w-full">
                {creators && creators?.length > 0 && (
                  <>
                    <SectionHeading
                      text="Creators"
                      className="font-bold max-sm:ml-4"
                    />
                    <Link
                      to={RouteName.SeeAllCreatorsRoute}
                      className="group shrink-0"
                    >
                      <p className="flex items-center gap-1 text-sm font-bold text-[#F50537] transition-all duration-200 group-hover:gap-2">
                        See all
                        <span className="transition-transform duration-200 group-hover:translate-x-0.5">
                          →
                        </span>
                      </p>
                    </Link>
                  </>
                )}
              </div>

              <div className="mx-auto">
                <Swiper
                  slidesPerView={6}
                  breakpoints={{
                    0: {
                      slidesPerView: 2,
                    },
                    350: {
                      slidesPerView: 2,
                    },
                    500: {
                      slidesPerView: 3,
                    },
                    1100: {
                      slidesPerView: 4,
                    },
                    1300: {
                      slidesPerView: 6,
                    },
                    1500: {
                      slidesPerView: 7,
                    },
                  }}
                  modules={[Pagination, Navigation]}
                  navigation={true}
                  className="mySwiper mx-auto mt-5 mb-5 w-full"
                >
                  {creators &&
                    creators?.map((value: any, i) => (
                      <SwiperSlide key={i}>
                        <div className="mx-auto w-full">
                          <CreatorCard creator={value} isLoading={isLoading} />
                        </div>
                      </SwiperSlide>
                    ))}
                </Swiper>
              </div>
            </Suspense>
          </ErrorBoundary>
        </>
      )}
      {isLoading && <CreatorArtistSkeleton />}
    </div>
  );
}

export default WelcomePageCreatorArtist;